import type { PropsWithChildren } from "react";
import { useSelector } from "react-redux";
import {
  AxiosInterceptors,
  createRequestLog,
  createResponseErrorLog,
  createResponseLog,
} from "@hopper-b2b/api";
import { useExperiments } from "@hopper-b2b/experiments";
import { getLang } from "@hopper-b2b/i18n";
import { getDelegatedTo } from "@hopper-b2b/self-serve";
import { useUserSource } from "@hopper-b2b/utilities";
import { branding } from "../../../config/branding";

export interface IAxiosInterceptors {
  version: string;
}

export const AxiosInterceptorWrapper = ({
  children,
  version,
}: PropsWithChildren<IAxiosInterceptors>) => {
  const { trackingProperties } = useExperiments();
  const userSource = useUserSource();
  const sessionId = sessionStorage.getItem("sessionId");
  const locale = getLang();
  const currency = branding.currencies?.[0]?.code;
  const headers = {};
  if (sessionId) headers["Riskified-Session-Id"] = sessionId;
  const tenant = branding.clientName;
  const delegatedTo = useSelector(getDelegatedTo);

  return (
    <AxiosInterceptors
      trackingProperties={trackingProperties}
      userSource={userSource}
      tenant={tenant}
      locale={locale}
      currency={currency}
      requestHeaders={headers}
      version={version}
      logResponse={createResponseLog}
      logRequest={createRequestLog}
      logError={createResponseErrorLog}
      delegatedTo={delegatedTo}
    >
      {children}
    </AxiosInterceptors>
  );
};
